// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../sfd-v2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../sfd-v2/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../sfd-v2/node_modules/css-loader/dist/cjs.js!../theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.epx-dmn-table {
  width: 100%;
  height: 100%;
  background: var(--epx-dmn-panel-bg);
  display: flex;
  flex-direction: row;
  overflow: hidden;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  color: var(--epx-dmn-panel-text);
}

.epx-dmn-table__main {
  flex: 1 1 auto;
  min-width: 0;
  overflow: auto;
  height: 100%;
}

.epx-dmn-table__scope {
  flex: 0 0 auto;
  height: 100%;
}

.epx-dmn-table__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: var(--epx-dmn-panel-text-faint);
  font-size: 13px;
}

.epx-dmn-table__scroll {
  padding: 16px;
  min-width: fit-content;
  width: 100%;
  box-sizing: border-box;
}

.epx-dmn-table__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.epx-dmn-table__title {
  font-size: 15px;
  font-weight: 600;
  color: var(--epx-dmn-panel-text);
  flex: 0 1 auto;
}

.epx-dmn-table__logic-chip {
  border: 1px solid var(--epx-dmn-accent-border, #cbd5e1);
  background: var(--epx-dmn-accent-bg, #eef2ff);
  color: var(--epx-dmn-accent, #3730a3);
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  letter-spacing: 0.2px;
}

.epx-dmn-table__logic-chip:hover { background: var(--epx-dmn-accent-alpha, #e0e7ff); }

.epx-dmn-table__logic-menu {
  position: fixed;
  z-index: 10001;
  background: var(--epx-dmn-panel-bg, #fff);
  color: var(--epx-dmn-panel-text, #1e293b);
  border: 1px solid var(--epx-dmn-panel-border, #cbd5e1);
  border-radius: 8px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.18);
  padding: 4px;
  min-width: 200px;
}

.epx-dmn-table__logic-item {
  display: block;
  width: 100%;
  text-align: left;
  border: 0;
  background: transparent;
  padding: 6px 10px;
  font-size: 12.5px;
  border-radius: 5px;
  cursor: pointer;
  color: var(--epx-dmn-panel-text, #1e293b);
}

.epx-dmn-table__logic-item:hover { background: var(--epx-dmn-panel-hover, #f1f5f9); }

.epx-dmn-table__logic-item.is-active {
  background: var(--epx-dmn-accent-bg, #e0e7ff);
  color: var(--epx-dmn-accent, #3730a3);
  font-weight: 600;
}

.epx-dmn-table__grid {
  border-collapse: collapse;
  background: var(--epx-dmn-panel-bg);
  table-layout: auto;
  width: 100%;
}

.epx-dmn-table__grid th,
.epx-dmn-table__grid td {
  border: 1px solid var(--epx-dmn-grid-border);
  padding: 0;
  vertical-align: middle;
  position: relative;
  background: var(--epx-dmn-panel-bg);
}

.epx-dmn-table__grid thead th {
  background: var(--epx-dmn-grid-header-bg);
  font-weight: 600;
}

.epx-dmn-table__hitpolicy-cell {
  background: var(--epx-dmn-grid-header-bg);
  border: 1px solid var(--epx-dmn-grid-border);
  padding: 6px;
  text-align: center;
  vertical-align: middle;
}
.epx-dmn-table__hitpolicy {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid var(--epx-dmn-accent-soft-border);
  background: var(--epx-dmn-accent-soft-bg);
  color: var(--epx-dmn-accent);
  font-weight: 800;
  font-size: 13px;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s;
}
.epx-dmn-table__hitpolicy:hover {
  background: var(--epx-dmn-accent-bg);
}
.epx-dmn-table__hitpolicy:focus-visible {
  outline: 2px solid var(--epx-dmn-accent);
  outline-offset: 2px;
}
.epx-dmn-table__hitpolicy-chev {
  font-size: 9px;
  opacity: 0.85;
  margin-top: 1px;
}

.epx-dmn-table__label {
  min-width: 110px;
  padding: 0 4px;
}
.epx-dmn-table__col-input {
  background: var(--epx-dmn-col-input-header-bg) !important;
}
.epx-dmn-table__col-output {
  background: var(--epx-dmn-col-output-header-bg) !important;
}

.epx-dmn-table__col-remove {
  width: 18px;
  height: 18px;
  line-height: 16px;
  font-size: 14px;
  border: none;
  background: transparent;
  color: var(--epx-dmn-panel-text-muted);
  cursor: pointer;
  padding: 0;
  border-radius: 50%;
}
.epx-dmn-table__col-remove:hover {
  background: var(--epx-dmn-danger);
  color: #fff;
}

.epx-dmn-table__col-header {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 6px 8px;
}
.epx-dmn-table__col-name-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  font-weight: 700;
  font-size: 13px;
}
.epx-dmn-table__col-actions {
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.15s;
}
.epx-dmn-table__col-input:hover .epx-dmn-table__col-actions,
.epx-dmn-table__col-output:hover .epx-dmn-table__col-actions,
.epx-dmn-table__col-input:focus-within .epx-dmn-table__col-actions,
.epx-dmn-table__col-output:focus-within .epx-dmn-table__col-actions {
  opacity: 1;
}
.epx-dmn-table__col-meta-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10.5px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  color: var(--epx-dmn-panel-text-muted);
  flex-wrap: wrap;
}

.epx-dmn-table__col-add {
  width: 26px;
  min-width: 26px;
  text-align: center;
  font-size: 16px;
  color: var(--epx-dmn-accent);
  cursor: pointer;
  user-select: none;
  background: var(--epx-dmn-panel-bg) !important;
}
.epx-dmn-table__col-add:hover {
  background: var(--epx-dmn-grid-header-bg) !important;
}

.epx-dmn-table__expr {
  font-weight: 400;
  font-style: italic;
  color: var(--epx-dmn-panel-text-muted);
  font-size: 11px;
}

.epx-dmn-table__annotation-header {
  min-width: 140px;
  background: var(--epx-dmn-grid-zebra) !important;
}

.epx-dmn-table__index {
  width: 32px;
  min-width: 32px;
  padding: 10px 8px;
  text-align: center;
  background: var(--epx-dmn-grid-index-bg) !important;
  color: var(--epx-dmn-panel-text-faint);
  font-weight: 700;
  border-right: 2px solid var(--epx-dmn-grid-border) !important;
  cursor: pointer;
  user-select: none;
}
.epx-dmn-table__index:hover {
  background: var(--epx-dmn-danger-soft) !important;
  color: var(--epx-dmn-danger);
}

.epx-dmn-table__cell {
  min-width: 110px;
}
.epx-dmn-table__cell-input {
  background: var(--epx-dmn-col-input-cell-bg);
}
.epx-dmn-table__cell-output {
  background: var(--epx-dmn-col-output-cell-bg);
}
.epx-dmn-table__annotation {
  background: var(--epx-dmn-grid-zebra);
  color: var(--epx-dmn-panel-text-muted);
  font-style: italic;
  min-width: 140px;
}

.epx-dmn-table__annot {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 8px;
}
.epx-dmn-table__annot > .epx-dmn-table__editable {
  flex: 1;
  padding: 10px 0;
}
.epx-dmn-table__annot-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--epx-dmn-bkm-fill);
  color: var(--epx-dmn-bkm-stroke);
  font-size: 10px;
  font-weight: 700;
  font-style: italic;
  flex-shrink: 0;
}

.epx-dmn-table__spacer {
  background: var(--epx-dmn-panel-bg) !important;
  border-top: none !important;
  border-bottom: none !important;
  width: 0;
  min-width: 0;
  padding: 0 !important;
}

.epx-dmn-table__editable {
  display: block;
  padding: 10px 14px;
  min-height: 22px;
  outline: none;
  font-family: "Menlo", "Consolas", "Courier New", monospace;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-word;
  cursor: text;
}
.epx-dmn-table__editable:focus {
  background: var(--epx-dmn-focus-bg);
  box-shadow: inset 0 0 0 2px var(--epx-dmn-accent);
}
.epx-dmn-table__editable--empty::before {
  content: attr(data-placeholder);
  color: var(--epx-dmn-panel-text-faint);
}
.epx-dmn-table__label .epx-dmn-table__editable {
  font-family: inherit;
  font-weight: 600;
  padding: 6px 20px 6px 8px;
}
.epx-dmn-table__expr .epx-dmn-table__editable {
  font-family: "Menlo", "Consolas", "Courier New", monospace;
  font-style: italic;
  padding: 4px 8px;
}

.epx-dmn-table__add-rule {
  text-align: center;
  padding: 10px !important;
  color: var(--epx-dmn-accent);
  font-weight: 600;
  cursor: pointer;
  border-top: 1px dashed var(--epx-dmn-panel-border) !important;
  background: transparent !important;
  user-select: none;
}
.epx-dmn-table__add-rule:hover {
  background: var(--epx-dmn-accent-soft-bg) !important;
}

.epx-dmn-table__hp-menu {
  position: fixed;
  min-width: 220px;
  background: var(--epx-dmn-panel-bg);
  border: 1px solid var(--epx-dmn-panel-border);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  z-index: 10010;
  padding: 4px 0;
}
.epx-dmn-table__hp-item {
  display: block;
  width: 100%;
  padding: 5px 14px;
  font-size: 12px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  color: var(--epx-dmn-panel-text);
}
.epx-dmn-table__hp-item:hover {
  background: var(--epx-dmn-grid-header-bg);
}
.epx-dmn-table__hp-item.is-active {
  background: var(--epx-dmn-accent);
  color: #fff;
}
.epx-dmn-table__hp-item-desc {
  display: block;
  font-size: 10px;
  color: var(--epx-dmn-panel-text-muted);
  margin-top: 2px;
  font-style: italic;
}
.epx-dmn-table__hp-item.is-active .epx-dmn-table__hp-item-desc {
  color: rgba(255, 255, 255, 0.85);
}
.epx-dmn-table__hp-sep {
  height: 1px;
  background: var(--epx-dmn-panel-border);
  margin: 4px 0;
}

.epx-dmn-table__col-issue {
  background: linear-gradient(to bottom, var(--epx-dmn-panel-bg) 0%, var(--epx-dmn-warning-soft) 100%) !important;
  box-shadow: inset 0 -2px 0 var(--epx-dmn-warning);
  position: relative;
}

.epx-dmn-table__col-issue::before {
  content: "⚠";
  position: absolute;
  top: 2px;
  left: 4px;
  color: var(--epx-dmn-warning-dark);
  font-size: 11px;
  pointer-events: none;
}

.epx-dmn-table__promote-btn {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 6px;
  border: 1px solid var(--epx-dmn-warning);
  border-radius: 3px;
  background: var(--epx-dmn-panel-bg);
  color: var(--epx-dmn-warning-dark);
  font-size: 10px;
  cursor: pointer;
}

.epx-dmn-table__promote-btn:hover {
  background: var(--epx-dmn-warning);
  color: #fff;
}

/* ── typeRef / values chips added for Step B ──────────────────────────── */
.epx-dmn-table__type-chip {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 6px;
  border: 1px solid var(--epx-dmn-input-border);
  border-radius: 10px;
  background: var(--epx-dmn-panel-bg);
  color: var(--epx-dmn-panel-text-muted);
  font-size: 10px;
  font-style: normal;
  cursor: pointer;
  user-select: none;
}
.epx-dmn-table__type-chip:hover {
  background: var(--epx-dmn-accent-bg);
  border-color: var(--epx-dmn-accent-border);
  color: var(--epx-dmn-accent);
}

.epx-dmn-table__values-chip {
  display: inline-block;
  margin-left: 4px;
  padding: 1px 6px;
  border: 1px dashed var(--epx-dmn-input-border);
  border-radius: 10px;
  background: transparent;
  color: var(--epx-dmn-panel-text-muted);
  font-size: 10px;
  cursor: pointer;
  user-select: none;
}
.epx-dmn-table__values-chip:hover {
  background: var(--epx-dmn-accent-bg);
  border-style: solid;
  border-color: var(--epx-dmn-accent-border);
  color: var(--epx-dmn-accent);
}
.epx-dmn-table__values-chip--set {
  border-style: solid;
  border-color: var(--epx-dmn-accent-border);
  background: var(--epx-dmn-accent-bg);
  color: var(--epx-dmn-accent);
  font-style: normal;
}

.epx-dmn-table__default-row td {
  background: var(--epx-dmn-grid-zebra);
  font-style: italic;
}
.epx-dmn-table__default-label {
  text-align: right;
  padding: 6px 8px !important;
  color: var(--epx-dmn-panel-text-muted);
  font-weight: 600;
}

/* ── dropdown menu for type / values (reuses hp-menu geometry) ────────── */
.epx-dmn-table__popover {
  position: fixed;
  min-width: 220px;
  background: var(--epx-dmn-panel-bg);
  border: 1px solid var(--epx-dmn-panel-border);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  z-index: 10010;
  padding: 6px 0;
}
.epx-dmn-table__popover-title {
  padding: 4px 12px;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--epx-dmn-panel-text-muted);
  font-weight: 600;
}
.epx-dmn-table__popover-item {
  display: block;
  width: 100%;
  padding: 5px 14px;
  font-size: 12px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  color: var(--epx-dmn-panel-text);
}
.epx-dmn-table__popover-item:hover {
  background: var(--epx-dmn-grid-header-bg);
}
.epx-dmn-table__popover-item.is-active {
  background: var(--epx-dmn-accent);
  color: #fff;
}
.epx-dmn-table__popover-body {
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.epx-dmn-table__popover-body textarea,
.epx-dmn-table__popover-body input {
  font-family: "Menlo", "Consolas", "Courier New", monospace;
  font-size: 12px;
  padding: 4px 6px;
  border: 1px solid var(--epx-dmn-input-border);
  border-radius: 3px;
  background: var(--epx-dmn-input-bg);
  color: var(--epx-dmn-panel-text);
  min-width: 260px;
}
.epx-dmn-table__popover-body textarea:focus,
.epx-dmn-table__popover-body input:focus {
  outline: none;
  border-color: var(--epx-dmn-accent);
  box-shadow: 0 0 0 2px var(--epx-dmn-accent-alpha);
}
.epx-dmn-table__popover-hint {
  font-size: 10px;
  color: var(--epx-dmn-panel-text-muted);
  font-style: italic;
}
.epx-dmn-table__popover-actions {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
}
.epx-dmn-table__popover-btn {
  padding: 4px 10px;
  font-size: 11px;
  border: 1px solid var(--epx-dmn-input-border);
  border-radius: 3px;
  background: var(--epx-dmn-panel-bg);
  color: var(--epx-dmn-panel-text);
  cursor: pointer;
}
.epx-dmn-table__popover-btn:hover {
  background: var(--epx-dmn-panel-hover);
}
.epx-dmn-table__popover-btn--primary {
  background: var(--epx-dmn-accent);
  border-color: var(--epx-dmn-accent);
  color: #fff;
}
.epx-dmn-table__popover-btn--primary:hover {
  background: var(--epx-dmn-accent-hover);
  border-color: var(--epx-dmn-accent-hover);
}

/* ── Simulation highlighting ────────────────────────────────────────── */
.epx-dmn-table__row--matched > td {
  background: rgba(16, 185, 129, 0.12) !important;
  box-shadow: inset 3px 0 0 var(--epx-dmn-success-text);
}
.epx-dmn-table__row--conflict > td {
  background: rgba(245, 158, 11, 0.14) !important;
  box-shadow: inset 3px 0 0 var(--epx-dmn-warning);
}
.epx-dmn-table__row--error > td {
  background: rgba(239, 68, 68, 0.12) !important;
  box-shadow: inset 3px 0 0 var(--epx-dmn-danger);
}
.epx-dmn-table__cell--error {
  outline: 2px solid var(--epx-dmn-danger);
  outline-offset: -2px;
}
.epx-dmn-table__row--pulse > td {
  animation: epx-dmn-pulse-row 0.9s ease;
}
.epx-dmn-table__cell--pulse {
  animation: epx-dmn-pulse-cell 0.9s ease;
}
@keyframes epx-dmn-pulse-row {
  0%, 100% { background-color: transparent; }
  30%      { background-color: rgba(59, 130, 246, 0.25); }
}
@keyframes epx-dmn-pulse-cell {
  0%, 100% { outline-color: transparent; }
  30%      { outline: 2px solid var(--epx-dmn-accent); outline-offset: -2px; }
}
`, "",{"version":3,"sources":["webpack://./../epx-dmn/src/table/styles.css"],"names":[],"mappings":"AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,2DAA2D;EAC3D,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,uDAAuD;EACvD,6CAA6C;EAC7C,qCAAqC;EACrC,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA,mCAAmC,gDAAgD,EAAE;;AAErF;EACE,eAAe;EACf,cAAc;EACd,yCAAyC;EACzC,yCAAyC;EACzC,sDAAsD;EACtD,kBAAkB;EAClB,8CAA8C;EAC9C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;AAC3C;;AAEA,mCAAmC,+CAA+C,EAAE;;AAEpF;EACE,6CAA6C;EAC7C,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,4CAA4C;EAC5C,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,4CAA4C;EAC5C,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mDAAmD;EACnD,yCAAyC;EACzC,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,0DAA0D;AAC5D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,sCAAsC;EACtC,eAAe;EACf,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,UAAU;EACV,yBAAyB;AAC3B;AACA;;;;EAIE,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6EAA6E;EAC7E,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,8CAA8C;AAChD;AACA;EACE,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mDAAmD;EACnD,sCAAsC;EACtC,gBAAgB;EAChB,6DAA6D;EAC7D,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iDAAiD;EACjD,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,OAAO;EACP,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;EAC3B,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,0DAA0D;EAC1D,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,mCAAmC;EACnC,iDAAiD;AACnD;AACA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,0DAA0D;EAC1D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,6DAA6D;EAC7D,kCAAkC;EAClC,iBAAiB;AACnB;AACA;EACE,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,6CAA6C;EAC7C,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,iCAAiC;EACjC,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,sCAAsC;EACtC,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,+GAA+G;EAC/G,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;EAClC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA,4EAA4E;AAC5E;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;EAC7C,mBAAmB;EACnB,mCAAmC;EACnC,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,8CAA8C;EAC9C,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,0CAA0C;EAC1C,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,6CAA6C;EAC7C,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,iCAAiC;EACjC,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;;EAEE,0DAA0D;EAC1D,eAAe;EACf,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;EAChC,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,mCAAmC;EACnC,iDAAiD;AACnD;AACA;EACE,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,6CAA6C;EAC7C,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,WAAW;AACb;AACA;EACE,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA,0EAA0E;AAC1E;EACE,+CAA+C;EAC/C,qDAAqD;AACvD;AACA;EACE,+CAA+C;EAC/C,gDAAgD;AAClD;AACA;EACE,8CAA8C;EAC9C,+CAA+C;AACjD;AACA;EACE,wCAAwC;EACxC,oBAAoB;AACtB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,WAAW,6BAA6B,EAAE;EAC1C,WAAW,0CAA0C,EAAE;AACzD;AACA;EACE,WAAW,0BAA0B,EAAE;EACvC,WAAW,wCAAwC,EAAE,oBAAoB,EAAE;AAC7E","sourcesContent":["@import url('../theme.css');\n\n.epx-dmn-table {\n  width: 100%;\n  height: 100%;\n  background: var(--epx-dmn-panel-bg);\n  display: flex;\n  flex-direction: row;\n  overflow: hidden;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  color: var(--epx-dmn-panel-text);\n}\n\n.epx-dmn-table__main {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: auto;\n  height: 100%;\n}\n\n.epx-dmn-table__scope {\n  flex: 0 0 auto;\n  height: 100%;\n}\n\n.epx-dmn-table__empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  color: var(--epx-dmn-panel-text-faint);\n  font-size: 13px;\n}\n\n.epx-dmn-table__scroll {\n  padding: 16px;\n  min-width: fit-content;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.epx-dmn-table__header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.epx-dmn-table__title {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--epx-dmn-panel-text);\n  flex: 0 1 auto;\n}\n\n.epx-dmn-table__logic-chip {\n  border: 1px solid var(--epx-dmn-accent-border, #cbd5e1);\n  background: var(--epx-dmn-accent-bg, #eef2ff);\n  color: var(--epx-dmn-accent, #3730a3);\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 11.5px;\n  font-weight: 600;\n  cursor: pointer;\n  letter-spacing: 0.2px;\n}\n\n.epx-dmn-table__logic-chip:hover { background: var(--epx-dmn-accent-alpha, #e0e7ff); }\n\n.epx-dmn-table__logic-menu {\n  position: fixed;\n  z-index: 10001;\n  background: var(--epx-dmn-panel-bg, #fff);\n  color: var(--epx-dmn-panel-text, #1e293b);\n  border: 1px solid var(--epx-dmn-panel-border, #cbd5e1);\n  border-radius: 8px;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.18);\n  padding: 4px;\n  min-width: 200px;\n}\n\n.epx-dmn-table__logic-item {\n  display: block;\n  width: 100%;\n  text-align: left;\n  border: 0;\n  background: transparent;\n  padding: 6px 10px;\n  font-size: 12.5px;\n  border-radius: 5px;\n  cursor: pointer;\n  color: var(--epx-dmn-panel-text, #1e293b);\n}\n\n.epx-dmn-table__logic-item:hover { background: var(--epx-dmn-panel-hover, #f1f5f9); }\n\n.epx-dmn-table__logic-item.is-active {\n  background: var(--epx-dmn-accent-bg, #e0e7ff);\n  color: var(--epx-dmn-accent, #3730a3);\n  font-weight: 600;\n}\n\n.epx-dmn-table__grid {\n  border-collapse: collapse;\n  background: var(--epx-dmn-panel-bg);\n  table-layout: auto;\n  width: 100%;\n}\n\n.epx-dmn-table__grid th,\n.epx-dmn-table__grid td {\n  border: 1px solid var(--epx-dmn-grid-border);\n  padding: 0;\n  vertical-align: middle;\n  position: relative;\n  background: var(--epx-dmn-panel-bg);\n}\n\n.epx-dmn-table__grid thead th {\n  background: var(--epx-dmn-grid-header-bg);\n  font-weight: 600;\n}\n\n.epx-dmn-table__hitpolicy-cell {\n  background: var(--epx-dmn-grid-header-bg);\n  border: 1px solid var(--epx-dmn-grid-border);\n  padding: 6px;\n  text-align: center;\n  vertical-align: middle;\n}\n.epx-dmn-table__hitpolicy {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  border-radius: 6px;\n  border: 1px solid var(--epx-dmn-accent-soft-border);\n  background: var(--epx-dmn-accent-soft-bg);\n  color: var(--epx-dmn-accent);\n  font-weight: 800;\n  font-size: 13px;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.epx-dmn-table__hitpolicy:hover {\n  background: var(--epx-dmn-accent-bg);\n}\n.epx-dmn-table__hitpolicy:focus-visible {\n  outline: 2px solid var(--epx-dmn-accent);\n  outline-offset: 2px;\n}\n.epx-dmn-table__hitpolicy-chev {\n  font-size: 9px;\n  opacity: 0.85;\n  margin-top: 1px;\n}\n\n.epx-dmn-table__label {\n  min-width: 110px;\n  padding: 0 4px;\n}\n.epx-dmn-table__col-input {\n  background: var(--epx-dmn-col-input-header-bg) !important;\n}\n.epx-dmn-table__col-output {\n  background: var(--epx-dmn-col-output-header-bg) !important;\n}\n\n.epx-dmn-table__col-remove {\n  width: 18px;\n  height: 18px;\n  line-height: 16px;\n  font-size: 14px;\n  border: none;\n  background: transparent;\n  color: var(--epx-dmn-panel-text-muted);\n  cursor: pointer;\n  padding: 0;\n  border-radius: 50%;\n}\n.epx-dmn-table__col-remove:hover {\n  background: var(--epx-dmn-danger);\n  color: #fff;\n}\n\n.epx-dmn-table__col-header {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 6px 8px;\n}\n.epx-dmn-table__col-name-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n  font-weight: 700;\n  font-size: 13px;\n}\n.epx-dmn-table__col-actions {\n  display: flex;\n  gap: 4px;\n  opacity: 0;\n  transition: opacity 0.15s;\n}\n.epx-dmn-table__col-input:hover .epx-dmn-table__col-actions,\n.epx-dmn-table__col-output:hover .epx-dmn-table__col-actions,\n.epx-dmn-table__col-input:focus-within .epx-dmn-table__col-actions,\n.epx-dmn-table__col-output:focus-within .epx-dmn-table__col-actions {\n  opacity: 1;\n}\n.epx-dmn-table__col-meta-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 10.5px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  color: var(--epx-dmn-panel-text-muted);\n  flex-wrap: wrap;\n}\n\n.epx-dmn-table__col-add {\n  width: 26px;\n  min-width: 26px;\n  text-align: center;\n  font-size: 16px;\n  color: var(--epx-dmn-accent);\n  cursor: pointer;\n  user-select: none;\n  background: var(--epx-dmn-panel-bg) !important;\n}\n.epx-dmn-table__col-add:hover {\n  background: var(--epx-dmn-grid-header-bg) !important;\n}\n\n.epx-dmn-table__expr {\n  font-weight: 400;\n  font-style: italic;\n  color: var(--epx-dmn-panel-text-muted);\n  font-size: 11px;\n}\n\n.epx-dmn-table__annotation-header {\n  min-width: 140px;\n  background: var(--epx-dmn-grid-zebra) !important;\n}\n\n.epx-dmn-table__index {\n  width: 32px;\n  min-width: 32px;\n  padding: 10px 8px;\n  text-align: center;\n  background: var(--epx-dmn-grid-index-bg) !important;\n  color: var(--epx-dmn-panel-text-faint);\n  font-weight: 700;\n  border-right: 2px solid var(--epx-dmn-grid-border) !important;\n  cursor: pointer;\n  user-select: none;\n}\n.epx-dmn-table__index:hover {\n  background: var(--epx-dmn-danger-soft) !important;\n  color: var(--epx-dmn-danger);\n}\n\n.epx-dmn-table__cell {\n  min-width: 110px;\n}\n.epx-dmn-table__cell-input {\n  background: var(--epx-dmn-col-input-cell-bg);\n}\n.epx-dmn-table__cell-output {\n  background: var(--epx-dmn-col-output-cell-bg);\n}\n.epx-dmn-table__annotation {\n  background: var(--epx-dmn-grid-zebra);\n  color: var(--epx-dmn-panel-text-muted);\n  font-style: italic;\n  min-width: 140px;\n}\n\n.epx-dmn-table__annot {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 8px;\n}\n.epx-dmn-table__annot > .epx-dmn-table__editable {\n  flex: 1;\n  padding: 10px 0;\n}\n.epx-dmn-table__annot-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: var(--epx-dmn-bkm-fill);\n  color: var(--epx-dmn-bkm-stroke);\n  font-size: 10px;\n  font-weight: 700;\n  font-style: italic;\n  flex-shrink: 0;\n}\n\n.epx-dmn-table__spacer {\n  background: var(--epx-dmn-panel-bg) !important;\n  border-top: none !important;\n  border-bottom: none !important;\n  width: 0;\n  min-width: 0;\n  padding: 0 !important;\n}\n\n.epx-dmn-table__editable {\n  display: block;\n  padding: 10px 14px;\n  min-height: 22px;\n  outline: none;\n  font-family: \"Menlo\", \"Consolas\", \"Courier New\", monospace;\n  font-size: 12px;\n  white-space: pre-wrap;\n  word-break: break-word;\n  cursor: text;\n}\n.epx-dmn-table__editable:focus {\n  background: var(--epx-dmn-focus-bg);\n  box-shadow: inset 0 0 0 2px var(--epx-dmn-accent);\n}\n.epx-dmn-table__editable--empty::before {\n  content: attr(data-placeholder);\n  color: var(--epx-dmn-panel-text-faint);\n}\n.epx-dmn-table__label .epx-dmn-table__editable {\n  font-family: inherit;\n  font-weight: 600;\n  padding: 6px 20px 6px 8px;\n}\n.epx-dmn-table__expr .epx-dmn-table__editable {\n  font-family: \"Menlo\", \"Consolas\", \"Courier New\", monospace;\n  font-style: italic;\n  padding: 4px 8px;\n}\n\n.epx-dmn-table__add-rule {\n  text-align: center;\n  padding: 10px !important;\n  color: var(--epx-dmn-accent);\n  font-weight: 600;\n  cursor: pointer;\n  border-top: 1px dashed var(--epx-dmn-panel-border) !important;\n  background: transparent !important;\n  user-select: none;\n}\n.epx-dmn-table__add-rule:hover {\n  background: var(--epx-dmn-accent-soft-bg) !important;\n}\n\n.epx-dmn-table__hp-menu {\n  position: fixed;\n  min-width: 220px;\n  background: var(--epx-dmn-panel-bg);\n  border: 1px solid var(--epx-dmn-panel-border);\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  z-index: 10010;\n  padding: 4px 0;\n}\n.epx-dmn-table__hp-item {\n  display: block;\n  width: 100%;\n  padding: 5px 14px;\n  font-size: 12px;\n  background: none;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  color: var(--epx-dmn-panel-text);\n}\n.epx-dmn-table__hp-item:hover {\n  background: var(--epx-dmn-grid-header-bg);\n}\n.epx-dmn-table__hp-item.is-active {\n  background: var(--epx-dmn-accent);\n  color: #fff;\n}\n.epx-dmn-table__hp-item-desc {\n  display: block;\n  font-size: 10px;\n  color: var(--epx-dmn-panel-text-muted);\n  margin-top: 2px;\n  font-style: italic;\n}\n.epx-dmn-table__hp-item.is-active .epx-dmn-table__hp-item-desc {\n  color: rgba(255, 255, 255, 0.85);\n}\n.epx-dmn-table__hp-sep {\n  height: 1px;\n  background: var(--epx-dmn-panel-border);\n  margin: 4px 0;\n}\n\n.epx-dmn-table__col-issue {\n  background: linear-gradient(to bottom, var(--epx-dmn-panel-bg) 0%, var(--epx-dmn-warning-soft) 100%) !important;\n  box-shadow: inset 0 -2px 0 var(--epx-dmn-warning);\n  position: relative;\n}\n\n.epx-dmn-table__col-issue::before {\n  content: \"⚠\";\n  position: absolute;\n  top: 2px;\n  left: 4px;\n  color: var(--epx-dmn-warning-dark);\n  font-size: 11px;\n  pointer-events: none;\n}\n\n.epx-dmn-table__promote-btn {\n  display: inline-block;\n  margin-left: 6px;\n  padding: 1px 6px;\n  border: 1px solid var(--epx-dmn-warning);\n  border-radius: 3px;\n  background: var(--epx-dmn-panel-bg);\n  color: var(--epx-dmn-warning-dark);\n  font-size: 10px;\n  cursor: pointer;\n}\n\n.epx-dmn-table__promote-btn:hover {\n  background: var(--epx-dmn-warning);\n  color: #fff;\n}\n\n/* ── typeRef / values chips added for Step B ──────────────────────────── */\n.epx-dmn-table__type-chip {\n  display: inline-block;\n  margin-left: 6px;\n  padding: 1px 6px;\n  border: 1px solid var(--epx-dmn-input-border);\n  border-radius: 10px;\n  background: var(--epx-dmn-panel-bg);\n  color: var(--epx-dmn-panel-text-muted);\n  font-size: 10px;\n  font-style: normal;\n  cursor: pointer;\n  user-select: none;\n}\n.epx-dmn-table__type-chip:hover {\n  background: var(--epx-dmn-accent-bg);\n  border-color: var(--epx-dmn-accent-border);\n  color: var(--epx-dmn-accent);\n}\n\n.epx-dmn-table__values-chip {\n  display: inline-block;\n  margin-left: 4px;\n  padding: 1px 6px;\n  border: 1px dashed var(--epx-dmn-input-border);\n  border-radius: 10px;\n  background: transparent;\n  color: var(--epx-dmn-panel-text-muted);\n  font-size: 10px;\n  cursor: pointer;\n  user-select: none;\n}\n.epx-dmn-table__values-chip:hover {\n  background: var(--epx-dmn-accent-bg);\n  border-style: solid;\n  border-color: var(--epx-dmn-accent-border);\n  color: var(--epx-dmn-accent);\n}\n.epx-dmn-table__values-chip--set {\n  border-style: solid;\n  border-color: var(--epx-dmn-accent-border);\n  background: var(--epx-dmn-accent-bg);\n  color: var(--epx-dmn-accent);\n  font-style: normal;\n}\n\n.epx-dmn-table__default-row td {\n  background: var(--epx-dmn-grid-zebra);\n  font-style: italic;\n}\n.epx-dmn-table__default-label {\n  text-align: right;\n  padding: 6px 8px !important;\n  color: var(--epx-dmn-panel-text-muted);\n  font-weight: 600;\n}\n\n/* ── dropdown menu for type / values (reuses hp-menu geometry) ────────── */\n.epx-dmn-table__popover {\n  position: fixed;\n  min-width: 220px;\n  background: var(--epx-dmn-panel-bg);\n  border: 1px solid var(--epx-dmn-panel-border);\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  z-index: 10010;\n  padding: 6px 0;\n}\n.epx-dmn-table__popover-title {\n  padding: 4px 12px;\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--epx-dmn-panel-text-muted);\n  font-weight: 600;\n}\n.epx-dmn-table__popover-item {\n  display: block;\n  width: 100%;\n  padding: 5px 14px;\n  font-size: 12px;\n  background: none;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  color: var(--epx-dmn-panel-text);\n}\n.epx-dmn-table__popover-item:hover {\n  background: var(--epx-dmn-grid-header-bg);\n}\n.epx-dmn-table__popover-item.is-active {\n  background: var(--epx-dmn-accent);\n  color: #fff;\n}\n.epx-dmn-table__popover-body {\n  padding: 8px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.epx-dmn-table__popover-body textarea,\n.epx-dmn-table__popover-body input {\n  font-family: \"Menlo\", \"Consolas\", \"Courier New\", monospace;\n  font-size: 12px;\n  padding: 4px 6px;\n  border: 1px solid var(--epx-dmn-input-border);\n  border-radius: 3px;\n  background: var(--epx-dmn-input-bg);\n  color: var(--epx-dmn-panel-text);\n  min-width: 260px;\n}\n.epx-dmn-table__popover-body textarea:focus,\n.epx-dmn-table__popover-body input:focus {\n  outline: none;\n  border-color: var(--epx-dmn-accent);\n  box-shadow: 0 0 0 2px var(--epx-dmn-accent-alpha);\n}\n.epx-dmn-table__popover-hint {\n  font-size: 10px;\n  color: var(--epx-dmn-panel-text-muted);\n  font-style: italic;\n}\n.epx-dmn-table__popover-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 6px;\n}\n.epx-dmn-table__popover-btn {\n  padding: 4px 10px;\n  font-size: 11px;\n  border: 1px solid var(--epx-dmn-input-border);\n  border-radius: 3px;\n  background: var(--epx-dmn-panel-bg);\n  color: var(--epx-dmn-panel-text);\n  cursor: pointer;\n}\n.epx-dmn-table__popover-btn:hover {\n  background: var(--epx-dmn-panel-hover);\n}\n.epx-dmn-table__popover-btn--primary {\n  background: var(--epx-dmn-accent);\n  border-color: var(--epx-dmn-accent);\n  color: #fff;\n}\n.epx-dmn-table__popover-btn--primary:hover {\n  background: var(--epx-dmn-accent-hover);\n  border-color: var(--epx-dmn-accent-hover);\n}\n\n/* ── Simulation highlighting ────────────────────────────────────────── */\n.epx-dmn-table__row--matched > td {\n  background: rgba(16, 185, 129, 0.12) !important;\n  box-shadow: inset 3px 0 0 var(--epx-dmn-success-text);\n}\n.epx-dmn-table__row--conflict > td {\n  background: rgba(245, 158, 11, 0.14) !important;\n  box-shadow: inset 3px 0 0 var(--epx-dmn-warning);\n}\n.epx-dmn-table__row--error > td {\n  background: rgba(239, 68, 68, 0.12) !important;\n  box-shadow: inset 3px 0 0 var(--epx-dmn-danger);\n}\n.epx-dmn-table__cell--error {\n  outline: 2px solid var(--epx-dmn-danger);\n  outline-offset: -2px;\n}\n.epx-dmn-table__row--pulse > td {\n  animation: epx-dmn-pulse-row 0.9s ease;\n}\n.epx-dmn-table__cell--pulse {\n  animation: epx-dmn-pulse-cell 0.9s ease;\n}\n@keyframes epx-dmn-pulse-row {\n  0%, 100% { background-color: transparent; }\n  30%      { background-color: rgba(59, 130, 246, 0.25); }\n}\n@keyframes epx-dmn-pulse-cell {\n  0%, 100% { outline-color: transparent; }\n  30%      { outline: 2px solid var(--epx-dmn-accent); outline-offset: -2px; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
